import React from 'react';
import { Link } from 'react-router-dom';

// Public registration is invite-only pre-launch (backend REGISTRATION_OPEN=false).
// The original registration form lives in git history — restore at launch.
const Register = () => (
  <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#07090c' }}>
    <div aria-hidden="true" className="pointer-events-none fixed inset-0"
      style={{ background: 'radial-gradient(ellipse 60% 40% at 50% -10%, rgba(198,242,78,0.08), transparent 70%)' }} />
    <div className="relative w-full max-w-md text-center">
      <Link to="/">
        <img src="/gritclicks-logo.png" alt="GritClicks" className="h-20 w-auto mx-auto mb-6" data-testid="register-logo" />
      </Link>
      <div className="rounded-2xl border border-white/10 bg-white/[0.03] py-10 px-8" data-testid="register-invite-only">
        <p className="text-[11px] font-bold tracking-[0.35em] uppercase mb-4" style={{ color: '#c6f24e' }}>Invite Only</p>
        <h1 className="text-2xl font-extrabold text-white mb-3">GritClicks is currently invite-only</h1>
        <p className="text-[#8494a5] text-sm mb-8">
          We're opening to a small group of founding contractors first.
          Join the early access list and we'll let you know the moment your spot is ready.
        </p>
        <Link to="/" data-testid="register-early-access-link"
          className="block w-full font-extrabold py-3.5 rounded-lg transition-colors"
          style={{ backgroundColor: '#c6f24e', color: '#07090c' }}>
          JOIN EARLY ACCESS
        </Link>
        <p className="text-sm text-[#8494a5] mt-6">
          Already have an account?{' '}
          <Link to="/login" className="font-semibold hover:underline" style={{ color: '#c6f24e' }} data-testid="register-login-link">Log in</Link>
        </p>
      </div>
    </div>
  </div>
);

export default Register;
